class FakeButton extends HTMLElement {
  constructor () {
    super()

    setTimeout(() => {
      this.addEventListener('click', this.handleInput)
    }, 2000)

    this.handleInput = this.handleInput.bind(this)
  }

  handleInput () {
    this.klaviyoButton.click()
  }

  get klaviyoButton () {
    return document.querySelector('.ft-Klaviyo_Form-desktop button')
  }
}

customElements.define('klaviyo-fake-button', FakeButton)
